/*
*  Array of languages, the first element is an English language.
*  Add a new object with texts for another language
*/

export default [
  { // EN
    formScreen: {
      title: 'Welcome to the Netwrix products <span class="no-wrap">Guided Tour</span>',
      paragraph: 'Experience Netwrix products with no download or installation required.<br class="hidden-xs"> To start your tour, <span class="no-wrap">fill out this form:</span>',
      formTitle: 'Netwrix product<br> Online Demo',
      buttonStates: {
        normal: 'Launch In-Browser Tour',
        requesting: 'Requesting…',
      },
      privacyText: 'We care about security of your data. <a href="/privacy.html" target="_blank">Privacy Policy</a>',
      contactUsText: 'If you have any questions, please <a class="no-wrap" href="/contact.html" target="_blank">contact us.</a>',
    },
    interimPageScreen: {
      paragraph: 'Click the button below to launch the guided tour in your browser. No installation is required.',
    },
    thankYouScreen: {
      title: 'We\'re almost ready to start<br class="visible-xs-inline"> <span class="no-wrap">your demo</span>',
      engineer: {
        img: '//img.netwrix.com/elements/onlineDemo/adam_stetson60.png',
        title: '<b>Adam Stetson,</b><br> <span>Systems Engineer</span>',
      },
      paragraph1: ' Hi!<br class="hidden-xs"> My name is Adam, and I’m a systems engineer at Netwrix. I will be guiding you on this product tour.',
      paragraph2: 'We sent an activation link to <span class="user-email">{userEmail}</span>. Please check your inbox and follow the link to complete your registration.',
      paragraph3: 'Don’t see our email in your inbox?',
      resendButtonCaption: 'Resend Link',
      resendButtonCaptionSending: 'Resending…',
      differentEmailButtonCaption: 'Enter Different Email',
    },
    gotoDesktopScreen: {
      title: 'We\'re almost ready to start<br class="visible-xs-inline"> <span class="no-wrap">your demo</span>',
      engineer: {
        img: '//img.netwrix.com/elements/onlineDemo/adam_stetson60.png',
        title: '<b>Adam Stetson,</b><br> <span>Systems Engineer</span>',
      },
      paragraph1: 'Hey there!',
      paragraph2: 'My name is Adam, and I’m your virtual guide to this product tour.',
      paragraph3: 'Unfortunately, I don’t fit the size of your mobile screen. Let’s start our interactive journey from your desktop!',
      paragraph4: 'I’ve just emailed a link to the in-browser demo to <span class="user-email">{userEmail}</span>. Please check your mailbox and click the link to get started!',
      contactUsText: 'If you have any questions, please <a class="no-wrap" href="/contact.html" target="_blank">contact us.</a>',
    },
    placeholders: {
      nwfFname: 'First Name',
      nwfLname: 'Last Name',
      nwfEmail: 'Business Email',
      accountType: 'User Type',
      nwfNsrv: 'Number of Employees',
      nwfPhone: 'Direct Phone',
      moreThanOption: 'More than 25,000',
    },
  },
  { // FR
    formScreen: {
      title: 'Bienvenue à la visite guidée des produits Netwrix',
      paragraph: 'Découvrez les produits Netwrix sans téléchargement ni installation requise.<br class="hidden-xs"> Pour commencer votre visite, <span class="no-wrap">remplissez ce formulaire :</span>',
      formTitle: 'Démo en ligne<br> du produit Netwrix',
      buttonStates: {
        normal: 'Commencer',
        requesting: 'En cours de traitement…',
      },
      privacyText: 'Nous nous chargeons de la sécurité de vos données. <a href="//www.netwrix.com/privacy_eu.html" target="_blank">Privacy Policy</a>',
      contactUsText: 'Pour toute question, veuillez <a href="https://www.netwrix.fr/contact.html" target="_blank">nous contacter.</a>',
    },
    thankYouScreen: {
      title: 'Nous sommes presque prêts à commencer.',
      engineer: {
        img: '//img.netwrix.com/elements/onlineDemo/thomas_limpens.jpg',
        title: '<b>Thomas Limpens,</b><br> Ingénieur Avant-vente',
      },
      paragraph1: 'Bonjour !<br class="hidden-xs"> Je m’appelle Thomas, je suis ingénieur Avant-vente chez Netwrix. Je vais vous guider dans cette visite du produit.',
      paragraph2: 'Je viens de vous envoyer un lien de confirmation d’adresse e-mail à <span class="user-email">{userEmail}</span>. Veuillez confirmer votre adresse e-mail et nous pourrons commencer !',
      paragraph3: 'Vous ne trouvez pas mon e-mail ?',
      resendButtonCaption: 'Renvoyer le lien ',
      resendButtonCaptionSending: 'En cours de traitement…',
      differentEmailButtonCaption: 'Saisir une autre adresse e-mail',
    },
    gotoDesktopScreen: {
      title: 'Nous sommes presque prêts à commencer.',
      engineer: {
        img: '//img.netwrix.com/elements/onlineDemo/thomas_limpens.jpg',
        title: '<b>Thomas Limpens,</b><br> Ingénieur Avant-vente',
      },
      paragraph1: 'Bonjour !',
      paragraph2: 'Je m\'appelle Thomas et je suis votre guide virtuel pour  ce tour du produit.',
      paragraph3: 'Malheureusement, je ne suis pas adapté à la taille de l\'écran de votre mobile. Commençons notre voyage interactif à partir de votre ordinateur!',
      paragraph4: 'Je viens d\'envoyer un lien vers la démo dans le navigateur par e-mail à <span class="user-email">{userEmail}</span>. Veuillez vérifier votre boîte aux lettres et cliquez sur le lien pour commencer !',
      contactUsText: 'Pour toute question, veuillez <a href="https://www.netwrix.fr/contact.html" target="_blank">nous contacter.</a>',
    },
    placeholders: {
      nwfFname: 'Prénom',
      nwfLname: 'Nom',
      nwfEmail: 'Email',
      accountType: 'Type d\'utilisateur',
      nwfNsrv: 'Taille de l’entreprise',
      nwfPhone: 'Téléphone',
      moreThanOption: 'Plus de 25,000',
    },
  },
  { // DE
    formScreen: {
      title: 'Willkommen bei Ihrer Tour zu den Produkten von Netwrix',
      paragraph: 'Lernen Sie die Produkte von Netwrix kennen, ohne sie herunterladen oder installieren zu müssen.<br class="hidden-xs"> Um mit Ihrer Tour zu beginnen, füllen Sie bitte <span class="no-wrap">dieses Formular aus:</span>',
      formTitle: 'Online-Demo<br> zum Netwrix-Produkt',
      buttonStates: {
        normal: 'Demo starten',
        requesting: 'Anfrage…',
      },
      privacyText: 'Die Sicherheit Ihrer Daten ist uns wichtig.<br> <a href="//www.netwrix.com/privacy_eu.html" target="_blank">Privacy Policy</a>',
      contactUsText: 'Bei Fragen setzen Sie sich bitte mit uns in <a href="https://www.netwrix.de/kontakte.html" target="_blank">Verbindung.</a>',
    },
    thankYouScreen: {
      title: 'Gleich geht es los',
      engineer: {
        img: '//img.netwrix.com/elements/onlineDemo/alex_bode.jpg',
        title: '<b>Alex Bode,</b><br> <span>Systems Engineer</span>',
      },
      paragraph1: ' Hallo!<br class="hidden-xs"> Ich heiße Alex und bin Systems Engineer bei Netwrix. Ich werde Sie durch die einzelnen Schritte dieser Tour führen.',
      paragraph2: 'Wir haben Ihnen soeben eine E-Mail mit einem Link zur Bestätigung Ihres Kontos an <span class="user-email">{userEmail}</span> gesendet. Bitte klicken Sie zur Bestätigung auf diesen Link, damit Sie die Tour starten können.',
      paragraph3: 'Die E-Mail wird nicht angezeigt?',
      resendButtonCaption: 'Link erneut senden',
      resendButtonCaptionSending: 'Anfrage…',
      differentEmailButtonCaption: 'Link an andere Adresse senden',
    },
    gotoDesktopScreen: {
      title: 'Gleich geht es los',
      engineer: {
        img: '//img.netwrix.com/elements/onlineDemo/alex_bode.jpg',
        title: '<b>Alex Bode,</b><br> <span>Systems Engineer</span>',
      },
      paragraph1: 'Hallo!',
      paragraph2: 'Ich heiße Alex und bin Ihr virtueller Tour Guide bei dieser Tour durch das Produkt.',
      paragraph3: 'Leider ist die Displaygröße Ihres Mobilgeräts nicht ausreichend. Starten Sie die interaktive Tour über Ihren Desktop-PC.',
      paragraph4: 'Ich habe soeben einen Link zur Browser-Demo an <span class="user-email">{userEmail}</span> gesendet. Bitte sehen Sie in Ihrem Postfach nach und klicken Sie auf den Link, um die Demo zu starten!',
      contactUsText: 'Bei Fragen setzen Sie sich bitte mit uns in <a href="https://www.netwrix.de/kontakte.html" target="_blank">Verbindung.</a>',
    },
    placeholders: {
      nwfFname: 'Vorname',
      nwfLname: 'Nachname',
      nwfEmail: 'Geschäftliche E-Mail',
      accountType: 'Anwendertyp',
      nwfNsrv: 'Firmengröße',
      nwfPhone: 'Direkte Telefonnummer',
      moreThanOption: 'Mehr als 25,000',
    },
  },
  { // IT
    formScreen: {
      title: 'Benvenuto nel tour guidato dei prodotti Netwrix',
      paragraph: 'Prova i prodotti Netwrix senza bisogno di scaricare o installare.<br class="hidden-xs"> Per iniziare il tuo tour, compila il seguente modulo:',
      formTitle: 'Demo online<br> del prodotto Netwrix',
      buttonStates: {
        normal: 'Inizia',
        requesting: 'Richiedi…',
      },
      privacyText: 'Ci preoccupiamo della sicurezza dei vostri dati. <a href="//www.netwrix.com/privacy_eu.html" target="_blank">Privacy Policy</a>',
      contactUsText: 'Se avete domande, non esitate a <a href="https://www.netwrix.it/contatti.html" target="_blank">contattarci.</a>',
    },
    thankYouScreen: {
      title: 'Siamo quasi pronti per iniziare',
      engineer: {
        img: '//img.netwrix.com/elements/onlineDemo/roberto.png',
        title: '<b>Roberto,</b><br> <span>Ingegnere di sistemi</span>',
      },
      paragraph1: 'Ehilà!<br class="hidden-xs"> Mi chiamo Roberto e sono un ingegnere di sistemi presso Netwrix.<br> Sarò la tua guida per questo tour del prodotto.',
      paragraph2: 'Ti ho appena inviato un link di verifica email a <span class="user-email">{userEmail}</span>. Ti prego di verificare la tua email e saremo pronti a partire!',
      paragraph3: 'Non riesci a trovare la mia email?',
      resendButtonCaption: 'Invia nuovamente link',
      resendButtonCaptionSending: 'Richiedi…',
      differentEmailButtonCaption: 'Inserisci nuova email',
    },
    gotoDesktopScreen: {
      title: 'Siamo quasi pronti per iniziare',
      engineer: {
        img: '//img.netwrix.com/elements/onlineDemo/roberto.png',
        title: '<b>Roberto,</b><br> <span>Ingegnere di sistemi</span>',
      },
      paragraph1: 'Ciao!',
      paragraph2: 'Sono Roberto e sono la tua guida virtuale a questo tour del prodotto.',
      paragraph3: 'Sfortunatamente, le dimensioni del tuo cellulare non vanno bene. Per iniziare il tour accedi dal tuo desktop.',
      paragraph4: 'Ho appena inviato tramite email il link dell\'inbrowser demo a <span class="user-email">{userEmail}</span>. Controlla la tua casella di posta e clicca sul link per iniziare!',
      contactUsText: 'Se avete domande, non esitate a <a href="https://www.netwrix.it/contatti.html" target="_blank">contattarci.</a>',
    },
    placeholders: {
      nwfFname: 'Nome',
      nwfLname: 'Cognome',
      nwfEmail: 'Business email',
      accountType: 'Tipologia utente',
      nwfNsrv: 'Numero di dipendenti',
      nwfPhone: 'Telefono diretto',
      moreThanOption: 'Più di 25,000',
    },
  },
  { // RU
    formScreen: {
      title: 'Добро пожаловать на интерактивное демо продукта Netwrix',
      paragraph: 'Чтобы познакомиться с продуктом, Вам не потребуется ничего скачивать и устанавливать.<br class="hidden-xs"> Чтобы начать обзор, <span class="no-wrap">заполните эту форму:</span>',
      formTitle: 'Интерактивное демо<br> продукта Netwrix',
      buttonStates: {
        normal: 'Начать работу',
        requesting: 'Запрос…',
      },
      privacyText: '<a href="//www.netwrix.com/privacy.html" target="_blank">Политика конфидециальности</a>',
      contactUsText: 'Если у Вас возникли вопросы, <a href="//www.netwrix.com/contact.html" target="_blank">свяжитесь с нами.</a>',
    },
    thankYouScreen: {
      title: 'Почти все готово',
      engineer: {
        img: '//img.netwrix.com/elements/onlineDemo/andrew.v001.jpg',
        title: '<b>Артём,</b><br> <span>Системный Инженер</span>',
      },
      paragraph1: ' Здравствуйте!<br class="hidden-xs"> Меня зовут Артём, я системный инженер компании Netwrix. Я познакомлю Вас с возможностями<br> продукта Netwrix.',
      paragraph2: 'Я только что отправил Вам ссылку для подтверждения адреса электронной почты на <span class="user-email">{userEmail}</span>. Пожалуйста, подтвердите свою электронную почту, и можем начинать!',
      paragraph3: 'Не видите сообщения?',
      resendButtonCaption: 'Отправить ссылку повторно',
      resendButtonCaptionSending: 'Запрос…',
      differentEmailButtonCaption: 'Ввести другой E-mail',
    },
    gotoDesktopScreen: {
      title: 'Почти все готово',
      engineer: {
        img: '//img.netwrix.com/elements/onlineDemo/andrew.v001.jpg',
        title: '<b>Артём,</b><br> <span>Системный Инженер</span>',
      },
      paragraph1: 'Привет!',
      paragraph2: 'Меня зовут Артём, и я проведу для Вас интерактивное демо.',
      paragraph3: 'Unfortunately, I don’t fit the size of your mobile screen. Let’s start our interactive journey from your desktop!',
      paragraph4: 'I’ve just emailed a link to the in-browser demo to <span class="user-email">{userEmail}</span>. Please check your mailbox and click the link to get started!',
      contactUsText: 'Если у Вас возникли вопросы, <a href="//www.netwrix.com/contact.html" target="_blank">свяжитесь с нами.</a>',
    },
    placeholders: {
      nwfFname: 'Имя',
      nwfLname: 'Фамилия',
      nwfEmail: 'Корпоративный email',
      accountType: 'Тип аккаунта',
      nwfNsrv: 'Количество сотрудников',
      nwfPhone: 'Контактный телефон',
      moreThanOption: 'Больше 25,000',
    },
  },
  { // ES
    formScreen: {
      title: 'Bienvenido a la visita guiada de los productos Netwrix',
      paragraph: 'Experimente con los productos de Netwrix sin necesidad de descargarlos ni instalarlos.<br class="hidden-xs"> Para iniciar su recorrido, llene este formulario:',
      formTitle: 'Demostración en línea<br> del producto Netwrix',
      buttonStates: {
        normal: 'Empezar',
        requesting: 'Request…',
      },
      privacyText: 'Nos preocupamos por la seguridad de sus datos. <a href="https://www.netwrix.com/privacy_eu.html" target="_blank">Privacy Policy</a>',
      contactUsText: 'Si tiene alguna pregunta, por favor <a class="no-wrap" href="https://www.netwrix.es/contact.html" target="_blank">contáctenos.</a>',
    },
    thankYouScreen: {
      title: 'Estamos casi listos para comenzar<br class="visible-xs-inline"> <span class="no-wrap">su demostración</span>',
      engineer: {
        img: '//img.netwrix.com/elements/onlineDemo/adam_stetson60.png',
        title: '<b>Adam Stetson,</b><br> <span>Ingeniero de sistemas</span>',
      },
      paragraph1: ' ¡Hola!<br class="hidden-xs"> Mi nombre es Adam y soy ingeniero de sistemas en Netwrix. Le guiaré en este recorrido por el producto.',
      paragraph2: 'Enviamos un enlace de activación a <span class="user-email">{userEmail}</span>. Por favor revise su bandeja de entrada y siga el enlace para completar su registro.',
      paragraph3: '¿No ves nuestro correo electrónico en tu bandeja de entrada?',
      resendButtonCaption: 'Reenviar enlace',
      resendButtonCaptionSending: 'Resending...',
      differentEmailButtonCaption: 'Ingrese un correo electrónico diferente',
    },
    gotoDesktopScreen: {
      title: 'Estamos casi listos para comenzar<br class="visible-xs-inline"> <span class="no-wrap">su demostración</span>',
      engineer: {
        img: '//img.netwrix.com/elements/onlineDemo/adam_stetson60.png',
        title: '<b>Adam Stetson,</b><br> <span>Ingeniero de sistemas</span>',
      },
      paragraph1: '¡Hola!',
      paragraph2: 'Mi nombre es Adam y soy su guía virtual para este recorrido por el producto.',
      paragraph3: 'Lamentablemente, no encaja en el tamaño de la pantalla de tu móvil. ¡Comencemos nuestro viaje interactivo desde su escritorio!',
      paragraph4: 'Acabo de enviar por correo electrónico un enlace a la demostración en el navegador a <span class="user-email">{userEmail}</span>. Por favor, compruebe su buzón de correo y haga clic en el enlace para empezar.',
      contactUsText: 'Si tiene alguna pregunta, por favor <a class="no-wrap" href="https://www.netwrix.es/contact.html" target="_blank">contáctenos.</a>',
    },
    placeholders: {
      nwfFname: 'Nombre de pila',
      nwfLname: 'Apellido',
      nwfEmail: 'Correo electrónico profesional',
      accountType: 'Tipo de usuario',
      nwfNsrv: 'Número de empleados',
      nwfPhone: 'Teléfono directo',
      moreThanOption: 'Más de 25,000',
    },
  },
];
